const responsiveImgMaps = () => {
    if ($("img[usemap]").length > 0) {
        $("img[usemap]").each(function() {
            $(this).load(function() {
                var mapSelector = $(this).attr("usemap"),
                    ratioW = $(this).width() / $(this)[0].naturalWidth;
                $("[name='" + $(this).attr("usemap").split("#").join('') + "']").find("area").each(function() {
                    if (!$(this).data("coords")) $(this).data("coords", $(this).attr("coords"));
                    var newCoords = "";
                    $($(this).data("coords").split(",")).each(function() {
                        if (newCoords) newCoords += ",";
                        newCoords += this * ratioW;
                    });
                    $(this).attr("coords", newCoords);
                });
            });
            $(this).trigger("load");
        });
    }
};

const beforeChange_slick = (carousel, imgUrl, imgMap, imgClass) => {
    var img = carousel.find('[data-slick-index="' + 0 + '"]').find('img'),
        url = img.data(imgUrl),
        map = img.data(imgMap);
    carousel.find('img').addClass(imgClass);
    img.attr({
        'src': url,
        'usemap': map
    }).fadeIn();
    carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        var _img = $(this).find('.item.slick-active').next('.item').find('img'),
            _url = _img.data(imgUrl),
            _map = _img.data(imgMap),
            src = _img.attr('src');
        if (typeof src == "undefined" || src == "" || src == " ")
            (_img) ? _img.attr({
                'src': _url,
                'usemap': _map
            }).show() : $(this).hide();
    });
}

const responsiveGenericCarousel_dt = () => {
    if ($('#carousel-example-generic').length > 0) {
      var url = 'deskimage',
          map = 'deskmap',
          imgClass = 'desktop-img',
          carousel = $('#carousel-example-generic');
      beforeChange_slick(carousel, url, map, imgClass);
      $('#carousel-example-generic .slick-dots li').on('click', function() {
          $('#carousel-example-generic img').each(function() {
              var img = $(this),
                  _url = img.data(url),
                  _map = img.data(map),
                  src = img.attr('src');
              if (typeof src == "undefined" || src == "" || src == " ") img.attr('src', _url).attr('usemap', _map).addClass(imgClass).show();
          });
      });
    }
    responsiveImgMaps();
}

const responsiveSplashCarousel_dt = () => {
    if ($('#homepage-carousel').length > 0) {
        var url = 'deskimage',
            map = 'deskmap',
            imgClass = 'desktop-img',
            carousel = $('#homepage-carousel');
        beforeChange_slick(carousel, url, map, imgClass);
        $('#homepage-carousel .slick-dots li').on('click', function() {
            $('#homepage-carousel img').each(function() {
                var img = $(this),
                    _url = img.data(url),
                    _map = img.data(map),
                    src = img.attr('src');
                if (typeof src == "undefined" || src == "" || src == " ") img.attr('src', _url).attr('usemap', _map).addClass(imgClass).show();
            });
        });
    }
    responsiveImgMaps();
}

const responsiveSplashCarousel_mobile = () => {
    if ($('#homepage-carousel').length > 0) {
        var url = 'mobileimage',
            map = 'mobilemap',
            imgClass = 'mobile-img',
            carousel = $('#homepage-carousel');
        beforeChange_slick(carousel, url, map, imgClass);
    }
    responsiveImgMaps();
}

export {
    responsiveGenericCarousel_dt,
    responsiveSplashCarousel_dt,
    responsiveSplashCarousel_mobile
}
